import { create } from "zustand";

import { getPublicMaintenanceBannerEnabled, getPublicMaintenanceBannerMessage } from "@/config/public-runtime-config";

interface MaintenanceBannerState {
  /** Message dismissed for the current page session (cleared on refresh). */
  dismissedMessage: string | null;
  dismiss: (message: string) => void;
}

export const useMaintenanceBanner = create<MaintenanceBannerState>(set => ({
  dismissedMessage: null,
  dismiss: message => {
    set({ dismissedMessage: message });
  },
}));

export function useMaintenanceBannerVisible(): boolean {
  const enabled = getPublicMaintenanceBannerEnabled();
  const message = getPublicMaintenanceBannerMessage();
  const dismissedMessage = useMaintenanceBanner(state => state.dismissedMessage);

  if (!enabled || !message) {
    return false;
  }

  return dismissedMessage !== message;
}
